import { render, staticRenderFns } from "./Interface.vue?vue&type=template&id=740d2ae8&scoped=true&"
import script from "./Interface.vue?vue&type=script&lang=js&"
export * from "./Interface.vue?vue&type=script&lang=js&"
import style0 from "./Interface.vue?vue&type=style&index=0&id=740d2ae8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740d2ae8",
  null
  
)

export default component.exports